// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_renewForSaleProperty(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["ForSalePropertyRenewed"]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"renewForSaleProperty_ForSalePropertyRenewed_property_client":{"f":""},"renewForSaleProperty_ForSalePropertyRenewed_property":{"f":""},"renewForSaleProperty":{"u":"response_renewForSaleProperty"}}};

let wrapResponseConverterMap = {
  response_renewForSaleProperty: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"renewForSaleProperty_ForSalePropertyRenewed_property_client":{"f":""},"renewForSaleProperty_ForSalePropertyRenewed_property":{"f":""},"renewForSaleProperty":{"u":"response_renewForSaleProperty"}}};

let responseConverterMap = {
  response_renewForSaleProperty: unwrap_response_renewForSaleProperty
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "propertyId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "propertyId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRenewable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeUntil",
      "storageKey": null
    }
  ],
  "type": "ActiveProperty",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusChangeComment",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusChangedAt",
  "storageKey": null
},
v9 = [
  (v6/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canDelete",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "matchingType",
    "storageKey": null
  },
  (v3/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenewForSalePropertyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "renewForSaleProperty",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ForSalePropertyV5",
                "kind": "LinkedField",
                "name": "property",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SellerPropertyStatusCallout_forSalePropertyV5"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ClientPageMatchingStatusLabel_matchable"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ChangeForSalePropertyStatus_forSalePropertyV5"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "MyClientsWidgetSeller_Menu_seller"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "MyClientsWidgetSeller_status_seller"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "ForSalePropertyRenewed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenewForSalePropertyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "renewForSaleProperty",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ForSalePropertyV5",
                "kind": "LinkedField",
                "name": "property",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expiredAt",
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "type": "ExpiredProperty",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "withdrawnAt",
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          (v6/*: any*/)
                        ],
                        "type": "WithdrawnProperty",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/)
                        ],
                        "type": "UnderContractProperty",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "soldPrice",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Price",
                                    "kind": "LinkedField",
                                    "name": "price",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "formatted",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "visibility",
                                    "storageKey": null
                                  }
                                ],
                                "type": "VisibleSoldPrice",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "type": "SoldProperty",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpiryInfoV5",
                    "kind": "LinkedField",
                    "name": "expiryInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activePeriodInDays",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ForSalePropertyV5",
                        "kind": "LinkedField",
                        "name": "property",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": "forSaleMatchingType",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "matchingType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "ExpiredProperty",
                                "abstractKey": null
                              },
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "SoldProperty",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "UnderContractProperty",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "WithdrawnProperty",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "if": null,
                            "kind": "Defer",
                            "label": "MyClientsWidgetSeller_Menu_seller$defer$MyClientsWidgetSeller_Menu_ActivityReportMenuItem_property",
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                  }
                                ],
                                "concreteType": "PropertyBroadcastConnection",
                                "kind": "LinkedField",
                                "name": "broadcasts",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PropertyBroadcastEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ForSalePropertyBroadcast",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "activityReport",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "broadcasts(first:1)"
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": "forSaleProperty",
                                "args": null,
                                "concreteType": "ForSalePropertyV5",
                                "kind": "LinkedField",
                                "name": "property",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "forSalePropertyMatchingType",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "matchingType",
                                    "storageKey": null
                                  },
                                  (v3/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Seller",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalPropertyV5",
                                "kind": "LinkedField",
                                "name": "property",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "rentalPropertyMatchingType",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "matchingType",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Landlord",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalNeedV5",
                                "kind": "LinkedField",
                                "name": "rentalNeed",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "Renter",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BuyerNeedV5",
                                "kind": "LinkedField",
                                "name": "buyerNeed",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "Buyer",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DevelopmentProject",
                                "kind": "LinkedField",
                                "name": "developmentProject",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Developer",
                            "abstractKey": null
                          }
                        ],
                        "type": "ClientV5",
                        "abstractKey": "__isClientV5"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activelyMatching",
                        "storageKey": null
                      }
                    ],
                    "type": "Matchable",
                    "abstractKey": "__isMatchable"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "ForSalePropertyRenewed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "410640aaf8132858e4ce069f2b33c064",
    "id": null,
    "metadata": {},
    "name": "RenewForSalePropertyMutation",
    "operationKind": "mutation",
    "text": "mutation RenewForSalePropertyMutation(\n  $propertyId: ID!\n) {\n  renewForSaleProperty(input: {id: $propertyId}) {\n    __typename\n    ... on ForSalePropertyRenewed {\n      property {\n        ...SellerPropertyStatusCallout_forSalePropertyV5\n        ...ClientPageMatchingStatusLabel_matchable\n        ...ChangeForSalePropertyStatus_forSalePropertyV5\n        client {\n          ...MyClientsWidgetSeller_Menu_seller\n          ...MyClientsWidgetSeller_status_seller\n          nodeId\n        }\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ChangeForSalePropertyStatus_forSalePropertyV5 on ForSalePropertyV5 {\n  id\n  nodeId\n  status {\n    __typename\n    ... on ActiveProperty {\n      isRenewable\n      activeUntil\n    }\n    ... on ExpiredProperty {\n      expiredAt\n    }\n  }\n  expiryInfo {\n    activePeriodInDays\n  }\n  client {\n    displayName\n    id\n    nodeId\n  }\n}\n\nfragment ClientPageMatchingStatusLabel_matchable on Matchable {\n  __isMatchable: __typename\n  __typename\n  activelyMatching\n}\n\nfragment ExpiredForSalePropertyCallout_expiredProperty on ExpiredProperty {\n  expiredAt\n  archived\n}\n\nfragment ExpiringForSalePropertyCallout_activeProperty on ActiveProperty {\n  activeUntil\n}\n\nfragment MyClientsWidgetDeleteDialog_clientV5 on ClientV5 {\n  __isClientV5: __typename\n  __typename\n  ... on Seller {\n    canDelete\n    forSaleProperty: property {\n      forSalePropertyMatchingType: matchingType\n      id\n      nodeId\n    }\n  }\n  ... on Landlord {\n    canDelete\n    property {\n      rentalPropertyMatchingType: matchingType\n      id\n      nodeId\n    }\n  }\n  ... on Renter {\n    canDelete\n    rentalNeed {\n      matchingType\n      id\n      nodeId\n    }\n  }\n  ... on Buyer {\n    canDelete\n    buyerNeed {\n      matchingType\n      id\n      nodeId\n    }\n  }\n  ... on Developer {\n    canDelete\n    developmentProject {\n      id\n      nodeId\n    }\n  }\n}\n\nfragment MyClientsWidgetSeller_Menu_ActivityReportMenuItem_property on ForSalePropertyV5 {\n  id\n  broadcasts(first: 1) {\n    edges {\n      node {\n        activityReport {\n          __typename\n          ... on ActivityReportV5 {\n            __typename\n          }\n        }\n        nodeId\n      }\n    }\n  }\n}\n\nfragment MyClientsWidgetSeller_Menu_seller on Seller {\n  id\n  property {\n    id\n    nodeId\n    forSaleMatchingType: matchingType\n    status {\n      __typename\n      ... on ExpiredProperty {\n        archived\n      }\n      ... on ActiveProperty {\n        isRenewable\n      }\n      ... on SoldProperty {\n        archived\n      }\n      ... on UnderContractProperty {\n        archived\n      }\n      ... on WithdrawnProperty {\n        archived\n      }\n    }\n    ...MyClientsWidgetSeller_Menu_ActivityReportMenuItem_property @defer(label: \"MyClientsWidgetSeller_Menu_seller$defer$MyClientsWidgetSeller_Menu_ActivityReportMenuItem_property\")\n  }\n  ...MyClientsWidgetDeleteDialog_clientV5\n}\n\nfragment MyClientsWidgetSeller_status_seller on Seller {\n  property {\n    ...OwnForSalePropertyStatusLabel_forSalePropertyV5\n    nodeId\n  }\n}\n\nfragment OwnForSalePropertyStatusLabel_forSalePropertyV5 on ForSalePropertyV5 {\n  status {\n    __typename\n    ... on ActiveProperty {\n      isRenewable\n      activeUntil\n    }\n    ... on ExpiredProperty {\n      __typename\n      archived\n    }\n    ... on SoldProperty {\n      __typename\n      archived\n    }\n    ... on UnderContractProperty {\n      __typename\n      archived\n    }\n    ... on WithdrawnProperty {\n      __typename\n      archived\n    }\n  }\n}\n\nfragment SellerPropertyStatusCallout_forSalePropertyV5 on ForSalePropertyV5 {\n  id\n  nodeId\n  status {\n    __typename\n    ... on ActiveProperty {\n      isRenewable\n      ...ExpiringForSalePropertyCallout_activeProperty\n    }\n    ... on ExpiredProperty {\n      ...ExpiredForSalePropertyCallout_expiredProperty\n    }\n    ... on WithdrawnProperty {\n      ...WithdrawnPropertyCallout_withdrawnProperty\n    }\n    ... on UnderContractProperty {\n      ...UnderContractPropertyCallout_underContractProperty\n    }\n    ... on SoldProperty {\n      ...SoldPropertyCallout_soldProperty\n    }\n  }\n}\n\nfragment SoldPropertyCallout_soldProperty on SoldProperty {\n  statusChangeComment\n  statusChangedAt\n  soldPrice {\n    __typename\n    ... on VisibleSoldPrice {\n      price {\n        formatted\n      }\n      visibility\n    }\n  }\n  archived\n}\n\nfragment UnderContractPropertyCallout_underContractProperty on UnderContractProperty {\n  statusChangeComment\n  archived\n  statusChangedAt\n}\n\nfragment WithdrawnPropertyCallout_withdrawnProperty on WithdrawnProperty {\n  withdrawnAt\n  statusChangeComment\n  archived\n}\n"
  }
};
})());

let wrap_response_renewForSaleProperty = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_renewForSaleProperty = unwrap_response_renewForSaleProperty;
exports.wrap_response_renewForSaleProperty = wrap_response_renewForSaleProperty;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
